/**
 * SUNUCU SAATI ile cihaz saati arasindaki fark.
 *
 * NEDEN VAR: talep kartlarindaki faz (offer -> decide -> payment -> passive) ve
 * geri sayimlar SUNUCU zaman damgalarindan turetiliyor. Saati yanlis kurulmus
 * bir cihaz `Date.now()` ile hesap yaptiginda dogru veriye ragmen YANLIS FAZ
 * gosterir — ve bu, kullanicinin sikayet edecegi ama loglarda hicbir izi
 * olmayan turden bir hatadir.
 *
 * Olcum, her yanitin `Date` basligindan alinir (bkz. src/api/client.ts).
 * Ayni kokenden servis edildigimiz icin baslik tarayiciya acik; CORS altinda
 * `Access-Control-Expose-Headers` gerekirdi.
 *
 * HASSASIYET: `Date` basligi saniye cozunurlugunde ve gidis-donus suresini
 * icermez; fark bir-iki saniye yanilabilir. Bu, dakikalar mertebesindeki faz
 * pencereleri icin fazlasiyla yeterli — daha iyisi icin NTP benzeri bir olcum
 * gerekirdi ve bu ise degmez.
 */

let offsetMs = 0;

/** Yanit basligindaki `Date` degerinden farki gunceller. */
export const noteServerDate = (headerValue: string | null | undefined): void => {
  if (!headerValue) return;
  const serverMs = Date.parse(headerValue);
  if (!Number.isFinite(serverMs)) return;
  offsetMs = serverMs - Date.now();
};

/** Sunucu saatine gore "simdi" (ms). Hic olcum yapilmadiysa Date.now(). */
export const serverNow = (): number => Date.now() + offsetMs;

/** Olculen fark (ms). Teshis/test icin. */
export const clockOffsetMs = (): number => offsetMs;

/** YALNIZ TESTLER ICIN. */
export const resetClockSkew = (): void => {
  offsetMs = 0;
};
